import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InterfaceService } from '../../../services/interface.service';
import { AllService } from '../../../services/all.service';
import { Subject } from 'rxjs';
import { IMessengerConnector } from '../../../types/all.type';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-message-editor-single',
  templateUrl: './message-editor-single.component.html',
  styleUrls: ['./message-editor-single.component.scss', './../../../components/chat-show/message-editor/message-editor.component.scss']
})
export class MessageEditorSingleComponent implements OnInit {
  @Output() onFocus = new EventEmitter<any>();
  @Output() onKeyUp = new EventEmitter<any>();
  @Output() onInput = new EventEmitter<any>();
  @Input() Service: IMessengerConnector;
  private destroy$: Subject<void> = new Subject();
  @Input() placeholder = '';
  @Input() formControl: AbstractControl | false = false;
  @Input() showImprove = true;

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
  ];
  constructor(
    public interfaceService: InterfaceService,
    public allService: AllService,
  ) { }

  ngOnInit(): void {
    this.interfaceService.editor = new Editor({
      content: '',
      history: true,
      keyboardShortcuts: true,
      inputRules: false,
      plugins: [], // https://prosemirror.net/docs/guide/#state
      nodeViews: {}, // https://prosemirror.net/docs/guide/#state,
      attributes: {}, // https://prosemirror.net/docs/ref/#view.EditorProps.attributes
      linkValidationPattern: '',
    });
  }
  public setTextAreaPosition() {
    this.allService.textAreaPosition = this.interfaceService.editor.view.state.selection.$anchor.pos;
  }

  get textMessage(): string {
    if (this.formControl) {
      return this.formControl.value;
    }
    return this.Service.message;
  }
  set textMessage(val) {
    if (this.formControl) {
      this.formControl.setValue(val);
    }
    this.Service.message = val;
  }
}
